import { Tooltip as ReactTooltip } from "react-tooltip";

export const Tooltip = ({ id, content, className = '' }) => {
  return (
    <>
      <span
        className={`info-icon ${className}`}
        type="button"
        data-tooltip-id={id}
      >
        <span className="p-button-icon pi pi-info-circle"></span>
      </span>
      <ReactTooltip
        id={id}
        place="bottom"
        openOnClick={true} // Opens on click instead of hover
        clickable={true}
        style={{
          fontFamily: "Barlow",
          fontSize: "14px",
          zIndex: 9999,
          width: "200px",
          background: "black",
          marginTop: "-10px",
        }}
        content={content}
      />
    </>
  )
}